import { render } from "./Home.vue?vue&type=template&id=3bd37963&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3bd37963&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd37963"],['__file',"src/views/h5/common/home/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bd37963"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bd37963', __exports__)) {
    api.reload('3bd37963', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=3bd37963&scoped=true", () => {
    api.rerender('3bd37963', render)
  })

}


export default __exports__